import { atom } from 'jotai';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';
import type { UserRole } from '@/entities/auth/model/auth.types';
import type { WorkspaceConfig, RouteConfigItem } from './workspace-config.types';
import { filterRoutesByViewMode } from './filterConfig';
import { FALLBACK_ROUTE_CONFIGS } from '@/shared/config/fallback-route-config';
import { authStateAtom } from '@/entities/auth/model/auth.atom';

export const workspaceConfigAtom = atom<WorkspaceConfig | null>(null);

/** sessionStorage 키 (clearAuth 시 제거용) */
export const VIEW_MODE_STORAGE_KEY = '__VIEW_MODE__';

export const viewModeAtom = atomWithStorage<UserRole>(
  VIEW_MODE_STORAGE_KEY,
  'Planner',
  createJSONStorage(() => sessionStorage)
);

/** viewMode + userRole 기준 필터링된 RouteConfigItem[] (userRole이 있으면 더 넓은 접근 허용) */
export const filteredRouteConfigsAtom = atom<RouteConfigItem[]>((get) => {
  const config = get(workspaceConfigAtom);
  const viewMode = get(viewModeAtom);
  const userRole = get(authStateAtom).user?.role ?? null;
  if (config?.routes) {
    return filterRoutesByViewMode(config.routes, viewMode, userRole);
  }
  return filterRoutesByViewMode(FALLBACK_ROUTE_CONFIGS, viewMode, userRole);
});

/** 필터링되지 않은 전체 RouteConfigItem[] (path → requiredRole 조회용) */
export const allRouteConfigsAtom = atom<readonly RouteConfigItem[]>((get) => {
  const config = get(workspaceConfigAtom);
  return config?.routes ?? FALLBACK_ROUTE_CONFIGS;
});
